import ajax from 'Site/js/util/ajax.fetch';
import ClubCard from 'Clubs/component/ClubCard.vue';
import Editable from 'Site/component/Editable.vue';
import EventCard from 'Parties/component/EventCard.vue';
import miniprofileDirective from 'Profile/directive/miniprofile';
import pagination from 'Site/js/mixin/pagination.input.check';
import PromptSignup from 'Site/js/mixin/prompt.signup';
import Wall from 'Wall/component/Wall.vue';
import WallPost from 'Wall/component/Post.vue';
import store from 'Site/js/store';
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';

export default function () {

    new Vue({ /* eslint no-new: 0 */
        el: '.page-layout',
        name: 'localSwingers',
        components: {
            ClubCard,
            Editable,
            EventCard,
            Wall,
            WallPost
        },
        data() {
            return {
                ajaxParams: {
                    url: 'location',
                    id: this.$store.state.config.data.id
                },
                description: this.$store.state.config.data.description,
                editMode: false,
                t: this.$store.state.t
            };
        },
        directives: {
            miniprofile: miniprofileDirective,
        },
        store,
        mixins: [pagination, PromptSignup]
    });

    const $nav = document.querySelector('.coverimage-header-bottom');

    if ($nav) {
        new Vue({ /* eslint no-new: 0 */
            el: '.city-header',
            name: 'localSwingersHeader',
            computed: mapState(['config']),
            data() {
                return {
                    subscribed: this.$store.state.config.data.isSubscribed
                };
            },
            methods: {
                ...mapActions(['notify']),
                navClick(section) {
                    document.querySelector(`#${section}`).scrollIntoView({ behavior: 'smooth', block: 'start' });
                },
                toggleSubscribe() {
                    if (this.subscribed.enabled) {
                        this.subscribed.enabled = false;
                        ajax.delete('locationSubscriber', { id: this.subscribed.id }).then((response) => {
                            this.notify({ msg: response.message });
                        });
                    } else {
                        this.subscribed.enabled = true;
                        ajax.create('locationSubscriber', { location: this.config.data.id }).then((response) => {
                            this.subscribed.id = response.id;
                            this.notify({ msg: response.message });
                        });
                    }
                },
            },
            store,
        });
    }
}
